import React, { useEffect, useMemo, useState } from "react";

import { SideNav, SideNavContent } from "components";
import BaseBarChart from "components/Chart/BaseBarChart";
import { MainBody, OverlayLoader, HeaderDasNew } from "components/core";
import DivisionBox from "./DivisionBox";
import BaseDoughnutChart from "components/Chart/BaseDoughnutChart";
import ProgressBar from "./ProgressBar";
import RenderSummary from "./RenderSummary";
import http from "services/httpService";
import Header from "./Header";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import routes from "components/routes";
import { useNavigate } from "react-router";
import { Button } from "@mui/material";
import EmptyDataLottie from "components/EmptyDataLottie";

const company_name = localStorage.getItem("company_name");

function ClaimDashboard() {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [noData, setNoData] = useState(false)

  const navigate = useNavigate();
  const redirectToClaimMIS = () => {
    navigate(`/${routes.CLAIMS_SUMMARY_MIS}`);
  };

  useEffect(async () => {
    try {
      const { data } = await http.get("/business/get_claims_metric_summary/");
      setData(data);
      console.log(data.claim_analysis.labels, data.claim_summary['Total Claims Submitted'] )
      if(data?.claim_analysis?.labels, data?.claim_summary['Total Claims Submitted']){
        setNoData(true)
      }
      setLoading(false);
    } catch (e) {
      console.log(e, "error data");
    }
  }, []);

  const getDatasets = (object_value) => {
    const { labels, ...datasets } = object_value;
    return datasets;
  };
  
  const sortedClaimSummary = useMemo(() => {
    if (!data.claim_summary) return [];
    const excludedKeys = ['updated_at', 'Total Claims Submitted'];
    return Object.entries(data.claim_summary)
      .filter(([key]) => key !== 'updated_at' && key !== 'Total Claims Submitted')
      .sort(([, a], [, b]) => b - a)
      .map(([key]) => key);
  }, [data]);

  const adjustedClaimAnalysis = useMemo(() => {
    if (!data.claim_analysis) return {};
  
    const { labels, ...datasets } = data.claim_analysis;
  
    // Initializing new datasets structure based on existing keys in datasets
    const newDatasets = Object.keys(datasets).reduce((acc, key) => {
      return {
        ...acc,
        [key]: {
          amounts: new Array(sortedClaimSummary.length).fill(0), // Initialize amounts array
          counts: new Array(sortedClaimSummary.length).fill(0)   // Initialize counts array
        }
      };
    }, {});
  
    sortedClaimSummary.forEach((sortedLabel, newIndex) => {
      const originalIndex = labels.indexOf(sortedLabel);
      if (originalIndex !== -1) {
        Object.keys(datasets).forEach((datasetKey) => {
          newDatasets[datasetKey].amounts[newIndex] = datasets[datasetKey].amounts[originalIndex];
          newDatasets[datasetKey].counts[newIndex] = datasets[datasetKey].counts[originalIndex];
        });
      }
    });
  
    return {
      labels: sortedClaimSummary,
      ...newDatasets
    };
  }, [data, sortedClaimSummary]);

  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav>
            <SideNavContent />
          </SideNav>
          <HeaderDasNew company_name={company_name} />
          <MainBody style={{ maxWidth: "1200px" }}>
            {noData?<div
              style={{ display: "flex", flexDirection: "column", gap: "4rem" }}
            >
              <DivisionBox
                style={{
                  height: "auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                }}
              >
                <Header last_updated_at={data?.claim_summary?.updated_at} />
                <RenderSummary data={data.claim_summary} />
                <Button
                  variant="contained"
                  onClick={redirectToClaimMIS}
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    background: "#2354D4",
                    fontSize: "14px",
                    borderRadius: "6px",
                    padding: "12px 24px",
                    marginTop: "24px",
                    textTransform: "capitalize",
                    fontFamily: "Inter",
                    width: "fit-content",
                  }}
                >
                  View Detailed Summary
                </Button>
              </DivisionBox>
              <section style={{ display: "flex", gap: "2rem" }}>
                <div style={{ width: "60%" }}>
                  <DivisionBox>
                    <BaseBarChart
                      labels={adjustedClaimAnalysis?.labels}
                      datasets={getDatasets(adjustedClaimAnalysis)}
                      title="Claim Amount by Status"
                    />
                  </DivisionBox>
                </div>
                <div style={{ width: "40%" }}>
                  <DivisionBox>
                    <ProgressBar data={data?.ailment_wise} />
                  </DivisionBox>
                </div>
              </section>
              <section>
                <DivisionBox>
                  <BaseBarChart
                    labels={data?.amount_band?.labels}
                    datasets={getDatasets(data?.amount_band)}
                    title="Claims Settled by Month"
                    hideLegend
                    stacked
                    combineDatasets
                  />
                </DivisionBox>
              </section>
              <section style={{ display: "flex", gap: "2rem" }}>
                <DivisionBox>
                  <BaseDoughnutChart
                    labels={data?.relation_wise?.labels}
                    cutout={100}
                    radius={160}
                    datasets={getDatasets(data?.relation_wise)}
                    title="Number of Claims Settled by Relation"
                  />
                </DivisionBox>
                <DivisionBox>
                  <BaseDoughnutChart
                    labels={data?.age_band?.label}
                    radius={220}
                    datasets={getDatasets(data?.age_band)}
                    title="Number of Claims Settled by Age-Band"
                  />
                </DivisionBox>
              </section>
            </div>:<EmptyDataLottie text="No Data Found"/>}
          </MainBody>
        </>
      )}
    </>
  );
}

export default ClaimDashboard;
